export const unscrambleId = (id) => {
  return id.split('.')[0];
};

export const unscrambleIntId = (id) => parseInt(unscrambleId(id), 10);

export const unscrambleArticleUrn = (urn) => {
  const ARTICLE_URN_RE = /(x-xing:companies:article):(.*)/;

  const groups = urn.match(ARTICLE_URN_RE);

  return groups ? `urn:${groups[1]}:${unscrambleId(groups[2])}` : null;
};
